import { cn } from '#src/styling/cn.ts';
import { Tooltip as TooltipPrimitive } from 'radix-ui';
import type { ComponentProps, ComponentPropsWithoutRef } from 'react';

export type TooltipRootProps = ComponentProps<typeof TooltipPrimitive.Root>;

const TooltipRoot = (props: TooltipRootProps) => {
  return <TooltipPrimitive.Root data-slot="tooltip" {...props} />;
};

export type TooltipTriggerProps = ComponentProps<typeof TooltipPrimitive.Trigger>;

const TooltipTrigger = (props: TooltipTriggerProps) => {
  return <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />;
};

export type TooltipContentProps = ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>;

const TooltipContent = ({ className, sideOffset = 4, ...props }: TooltipContentProps) => (
  <TooltipPrimitive.Content
    data-slot="tooltip-content"
    sideOffset={sideOffset}
    className={cn(
      'bg-popover text-popover-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 overflow-hidden rounded-md border px-3 py-1.5 text-sm shadow-md',
      className,
    )}
    {...props}
  />
);

export const Tooltip = {
  Root: TooltipRoot,
  Trigger: TooltipTrigger,
  Content: TooltipContent,
  Provider: TooltipPrimitive.Provider,
};
